<script lang="ts">
  import CheckboxTickIcon from '$icons/CheckboxTickIcon.svelte';
  import { cn } from '$lib/utils/misc';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  $: id = crypto.randomUUID();
  export let checked = false;
  export let name = '';
  export let label = '';
  export let description = '';
  export let disabled = false;
</script>

<label
  for={id}
  class={cn(
    'flex cursor-pointer gap-x-2',
    description ? 'items-start' : 'items-center',
    $$props.class,
  )}
>
  <input
    type="checkbox"
    {disabled}
    {name}
    {id}
    bind:checked
    class="sr-only"
    on:change={() => dispatch('change', checked)}
  />
  <div class="checkbox">
    <CheckboxTickIcon />
  </div>
  <div class="text-gray-dark-12 text-sm font-normal leading-4">
    <p>{label}</p>
    <p class="mt-2xs text-gray-dark-11">{description}</p>
  </div>
</label>

<style lang="postcss">
  .checkbox {
    @apply border-gray-dark-6 p-sm ml-[3px] flex h-5 w-5 cursor-pointer items-center justify-center rounded border text-transparent ring-[3px] ring-transparent;
  }
  input[type='checkbox']:hover ~ .checkbox {
    @apply text-gray-dark-6;
  }
  input[type='checkbox']:focus ~ .checkbox {
    @apply border-mint-dark-8 text-gray-dark-6 ring-mint-dark-4;
  }
  input[type='checkbox']:disabled ~ .checkbox {
    @apply bg-gray-dark-3;
  }
  input[type='checkbox']:checked ~ .checkbox {
    @apply border-mint-dark-8 bg-mint-dark-3 text-mint-dark-11;
  }
  input[type='checkbox']:checked:hover ~ .checkbox {
    @apply border-mint-dark-5 bg-mint-dark-3 text-mint-dark-11;
  }
  input[type='checkbox']:checked:disabled ~ .checkbox {
    @apply border-mint-dark-4 bg-mint-dark-3 text-mint-dark-7;
  }
</style>
